import styled from "styled-components";
import { Link as RouterLink } from "react-router-dom";

interface BakeImageProps {
  imageURL: string;
}

export const CardContainer = styled.div`
  margin: 0 15px;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  max-width: 700px;
  margin: 0 auto;
  background-color: ${(props) => props.theme.color.white};
  border-radius: 12px;
  box-shadow: rgba(50, 50, 93, 0.10) 0px 50px 100px -20px, rgba(0, 0, 0, 0.10) 0px 30px 60px -30px;
  font-family: ${(props) => props.theme.font.montserrat};
  color: ${(props) => props.theme.color.pink};
  font-weight: normal;
`;

export const BakeImage = styled.div<BakeImageProps>`
  background-image: url(${(props) => props.imageURL});
  width: 100%;
  height: 350px;
  background-size: cover;
  background-position: center;
  margin: 0 auto;
  border-radius: 12px 12px 0 0;
`;

export const StyledRouterLink = styled(RouterLink)`
  text-decoration: none;
  color: ${(props) => props.theme.color.pink};

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;

export const Link = styled.a`
  text-decoration: none;
  color: ${(props) => props.theme.color.pink};
  font-weight: bold;
  text-decoration: none;

  &:focus,
  &:hover {
    text-decoration: underline;
  }
`;

export const Button = styled.button`
  display: block;
  color: ${(props) => props.theme.color.white};
  background: ${(props) =>
    props.disabled ? props.theme.color.grey : props.theme.color.pink};
  outline: none;
  border: none;
  border-radius: 20px;
  margin: 20px auto 0 auto;
  padding: 6px 18px;
  font-family: ${(props) => props.theme.font.montserrat};
  font-weight: bold;
  font-size: 22px;
  cursor: ${(props) => (props.disabled ? "default" : "pointer")};
  &:focus,
  &:hover,
  &:visited,
  &:link {
    background-color: ${(props) =>
      props.disabled ? "none" : props.theme.color.darkPink};
  }
`;
